
import React, { useEffect, useState } from 'react';
import MyLineChart from "../dashboard/linechart";
import Layout from "../layout";
import BasicIcon from '../../../assets/Healthiness/Icon heart rate.png'
import VitalIcon from '../../../assets/Healthiness/Icon Breathing rate.png'
import RecIcon from '../../../assets/Healthiness/Icon SpO2.png'
import bg from '../../../assets/wellness/Vitamin.png'
import MyChart2 from "../dashboard/mychart2";
import { fetchWeeklyData, fetchLatestScore } from '../../firebase/scans';
import LeftSection from '../../common/LeftSection';
import Tooltip from '../../common/Tooltip';

const BasicVitalDash = () => {
    const [bchartData,setBChartData]=useState([]);
    const [cchartData,setCChartData]=useState([]);
    const [hchartData,setHChartData]=useState([]);
    const setDefaultChartData = async()=>{
        let bresp = await fetchWeeklyData(2,'Heart Rate');
        let cresp = await fetchWeeklyData(3,'SpO2 Level');
        let hresp = await fetchWeeklyData(4,'Breathing Rate');
        if (bresp[0] !== 0){
            setBChartData(bresp);
            setCChartData(cresp);
            setHChartData(hresp);
        }
    }    
    useEffect(()=>{
        setDefaultChartData();
    },[])
    return (
      <div
        className=" w-full flex flex-col md:flex-row pl-3"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSized: "cover",
          backgroundRepeat: "repeat",
        }}
      >
        <div className="grow">
          <div className="flex flex-col md:flex-row  pt-1 w-full">
            <div className="flex flex-row md:my-auto mx-auto md:mx-0 mb-4 pr-12 md:w-1/4">
              <div>
                <img src={BasicIcon} className="h-12" />
              </div>
              <div className="flex flex-col">
                <div className=" my-auto ml-3 text-orange-400 font-bold">
                  Heart Rate
                </div>
                <div>
                  <Tooltip
                    text="This shows the 7-day trending of Heart rate with the average. Click the right arrow to check the detail.
"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row w-3/4">
              <div className="md:w-1/2">
                <MyChart2 data={bchartData} />
              </div>
              <a
                href="/basicvitals/heart-rate"
                className="text-2xl my-auto hover:bg-gray-300 p-3"
              >
                {">"}
              </a>
            </div>
          </div>
          <div className="flex flex-col md:flex-row pt-1">
            <div className="flex flex-row mb-4 md:my-auto pr-12 mx-auto md:mx-0 md:w-1/4">
              <div>
                <img src={RecIcon} className="h-12" />
              </div>
              <div className="flex flex-col">
                <div className=" my-auto ml-3 text-orange-400 font-bold">
                  Breathing Rate
                </div>
                <div>
                  <Tooltip
                    text="This shows the 7-day trending of Breathing rate with the average. Click the right arrow to check the detail.
"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row w-3/4">
              <div className="md:w-1/2">
                <MyChart2 data={hchartData} />
              </div>
              <a
                href="/basicvitals/breathing-rate"
                className="text-2xl my-auto hover:bg-gray-300 p-3"
              >
                {">"}
              </a>
            </div>
          </div>
          <div className="flex flex-col md:flex-row pt-1 mb-9">
            <div className="flex flex-row mb-4 md:my-auto pr-12 mx-auto md:mx-0 md:w-1/4">
              <div>
                <img src={VitalIcon} className="h-12" />
              </div>
              <div className="flex flex-col">
                <div className=" my-auto ml-3 text-orange-400 font-bold">
                  SpO2
                </div>
                <div>
                  <Tooltip
                    text="This shows the 7-day trending of SPO2 rate with the average. Click the right arrow to check the detail.
"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row w-3/4">
              <div className="md:w-1/2 ">
                <MyChart2 data={cchartData} />
              </div>
              <a
                href="/basicvitals/spo2"
                className="text-2xl my-auto hover:bg-gray-300 p-3"
              >
                {">"}
              </a>
            </div>
          </div>
        </div>
        <div className="flex">
          <LeftSection />
        </div>
      </div>
    );
}
 
export default BasicVitalDash;